export const otpMedium = {
    otpSendMedium: [{
        sms: 1
    }]
};

export const errorMsg = {
    firstName: {
        invalid: "Please enter valid First Name Allowed",
        empty: "First name is required",
    },
    lastName: {
        invalid: "Please enter valid Last Name Allowed",
        empty: "Last name is required",
    },
    phoneNumber: {
        invalid: "Enter the valid Phone Nummber",
        empty: "Please enter the Phone Number"
    },
    emailId: {
        invalid: "Please enter a valid email address",
        empty: "Please enter email address",
        already: "This email is already associated with other account or partner",
    },
    password: {
        invalid: "Your password does not meet our security criteria",
        empty: "Please enter password"
    },
    confirmPassword: {
        invalid: "Your password does not match",
        empty: "Please enter confirm password"
    },
    otp: {
        invalid: "Please enter a valid OTP",
        empty: "Please enter OTP"
    },
    somethingErr: "Something went wrong. Try again later."
}

export const successMsg = {
    forgotLinkSent: 'A reset password link has been sent to your registered email address. Click the link to create a new password.',
    otpSent: 'OTP has been sent to your email address and phone number.',
}

export const hideSideImageForUrlPaths = ["/account/redirect", "/account/unauthorizedaccess", "/account/activation", '/account/invalid'];

export const specialIPv4 = [
    {
        "value": "203.110.90.18", 
        "label": "IndianOffice"
    },
    {
        "value": "23.25.130.161",
        "label": "AmericanOffice"
    }
];
export const nonOtpId = ["8b818f5e-74df-48fa-af23-a71b9069a243","305BF342-40F2-4AE3-A8C0-4AC8C3754279","9E6EA069-3EFF-429A-8FFD-6A082F1C72B3","A4C6085F-6A0E-450C-B55F-A387F4378CE4","b1890b86-6554-47f1-97cb-8c0357449bde"] 
                                                                 